import * as http from 'axios'
export const getTiposRede = (q) => http.get(`/redeTipos?sort=nome&nome__regex=/.*${q}.*/i`)



// WEBPACK FOOTER //
// ./src/store/tipoRede/services.js